import React from 'react';
import { get } from 'lodash';
import { withRouter } from 'react-router-dom';

// React view component to render
import { SERVICE_RESPONSE_STATUS } from 'constants/common';
import { memberDetailsSavingsAlternateDrugsWidget as MemberDetailsSavingsAlternateDrugsWidgetView } from 'ui/views/widgets/memberDetailsSavingsAlternateDrugsWidget';
import { MemberDetailsSavingsAlternateDrugsWidgetService } from 'services/memberDetailsSavingsAlternateDrugsWidget';

/**
 * @type {class}
 * @desc A React container/smart component to render a React presentational/dumb component (view).
 * @example
 * import { MemberDetailsSavingsAlternateDrugsWidget } from 'ui/containers/MemberDetailsSavingsAlternateDrugsWidget';
 *
 * // render
 * <MemberDetailsSavingsAlternateDrugsWidget propName='propValue'/>
 */
class _MemberDetailsSavingsAlternateDrugsWidget extends React.Component {
    
    /**
     * @param {object} props - props
     */
    constructor( props ) {
        super( props );

        // component state
        this.state = {
            isFetching: true,
            networkStatus: undefined,
            componentData: undefined,
        };

        // Member Detail instance
        this.memberDetailsSavingsAlternateDrugsWidgetService = new MemberDetailsSavingsAlternateDrugsWidgetService();

        // start member detail data fetch
        this.fetchComponentData();
    }

    /*********************************************/

    /**
     * @desc Fetch member detail information.
     */
    async fetchComponentData() {
        log.debug( 'MemberDetailsSavingsAlternateDrugsWidgetService.memberDetailsSavingsAlternateDrugsWidgetService()' );
        
        // cancel ongoing request
        this.memberDetailsSavingsAlternateDrugsWidgetService.cancel();

        try {
            const { status, data }  = await this.memberDetailsSavingsAlternateDrugsWidgetService.fetchData( {
                url: this.props.widget.url,
                data: this.props.requestPayload
            } );

            // check if response status was success
            if( SERVICE_RESPONSE_STATUS.SUCCESS !== status ) {
                this.setState( {
                    isFetching: false,
                    networkStatus: SERVICE_RESPONSE_STATUS.FAILURE
                } );
            } else {
                this.setState( {
                    isFetching: false,
                    networkStatus: SERVICE_RESPONSE_STATUS.SUCCESS,
                    componentData: data,
                } );
            }

        } catch( e ) {
            this.setState( {
                isFetching: false,
                networkStatus: SERVICE_RESPONSE_STATUS.FAILURE,
            } );
        }
    }

    /*********************************************/

    /**
     * @desc When component unmounts, cleanup resouces.
     */
    componentWillUnmount() {
        this.memberDetailsSavingsAlternateDrugsWidgetService.cancel(); // cancel ongoing requests
    }

    /**
     * @desc Render a React view component
     */
    render() {
        return (
            <MemberDetailsSavingsAlternateDrugsWidgetView
                isFetching={ this.state.isFetching }
                networkStatus={ this.state.networkStatus }
                { ...get( this.state, 'componentData', {} ) }
                { ...this.props }
            />
        );
    }
}

// set display name
_MemberDetailsSavingsAlternateDrugsWidget.displayName = 'MemberDetailsSavingsAlternateDrugsWidget';

// set default props
_MemberDetailsSavingsAlternateDrugsWidget.defaultProps = {
    memberId: null,
    requestPayload: {},
};

// prop types
_MemberDetailsSavingsAlternateDrugsWidget.propTypes = {};

export const MemberDetailsSavingsAlternateDrugsWidget = withRouter( _MemberDetailsSavingsAlternateDrugsWidget );
